// Centralised data-testid registry
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  signin: "landing-signin-btn",
  getStarted: "landing-get-started-btn",
  navBrand: "landing-brand",
  heroPrimary: "landing-hero-primary",
  heroSecondary: "landing-hero-secondary",
  ctaCard: "landing-cta-card",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  phoneInput: "auth-phone-input",
  countryInput: "auth-country-input",
  roleClient: "auth-role-client",
  roleAgent: "auth-role-agent",
  submitBtn: "auth-submit-btn",
  googleBtn: "auth-google-btn",
  toggleLink: "auth-toggle-link",
  errorAlert: "auth-error-alert",
};

export const NAV = {
  brand: "nav-brand",
  dashboard: "nav-dashboard",
  newTask: "nav-new-task",
  logout: "nav-logout",
  profile: "nav-profile",
};

export const CLIENT = {
  createTask: "client-create-task-btn",
  taskCard: "client-task-card",
  emptyState: "client-empty-state",
};

export const TASK_WIZARD = {
  catBtn: "wizard-cat",
  next: "wizard-next",
  back: "wizard-back",
  submit: "wizard-submit",
  title: "wizard-title",
  desc: "wizard-desc",
  city: "wizard-city",
  address: "wizard-address",
  budget: "wizard-budget",
  deadline: "wizard-deadline",
  instructions: "wizard-instructions",
  recipientName: "wizard-recipient-name",
  recipientPhone: "wizard-recipient-phone",
  purchaseType: "wizard-purchase-type",
};

export const TASK = {
  funEscrowBtn: "task-fund-escrow-btn",
  funItemBtn: "task-fund-item-btn",
  fundBundleBtn: "task-fund-bundle-btn",
  stripeBtn: "task-stripe-pay-btn",
  stripeBundleBtn: "task-stripe-bundle-btn",
  pay2holdBtn: "task-pay2hold-btn",
  invoiceCard: "task-invoice-card",
  claimBtn: "task-claim-btn",
  startBtn: "task-start-btn",
  finishBtn: "task-finish-btn",
  approveBtn: "task-approve-btn",
  addPhotoBtn: "task-add-photo-btn",
  photoCaption: "task-photo-caption",
  photoFile: "task-photo-file",
  rateStars: "task-rate-star",
  rateSubmit: "task-rate-submit",
  chatInput: "task-chat-input",
  chatSend: "task-chat-send",
  chatMessage: "task-chat-message",
  receiptBtn: "task-receipt-btn",
  disputeBtn: "task-dispute-btn",
  disputeReason: "task-dispute-reason",
  disputeSubmit: "task-dispute-submit",
};

export const AGENT = {
  kycBtn: "agent-kyc-btn",
  kycSubmit: "agent-kyc-submit",
  kycIdFile: "agent-kyc-id-file",
  kycSelfieFile: "agent-kyc-selfie-file",
  marketplaceCard: "agent-market-card",
};

export const ADMIN = {
  approveAgent: "admin-approve-agent",
  rejectAgent: "admin-reject-agent",
  tab: "admin-tab",
  resolveRefund: "admin-resolve-refund",
  resolveRelease: "admin-resolve-release",
  resolveNone: "admin-resolve-none",
  photoQueueRow: "admin-photo-queue-row",
  approvePhoto: "admin-approve-photo",
  rejectPhoto: "admin-reject-photo",
};
